import { HeaderDesignControllerContextData } from 'src/hooks/useHeaderDesignController';
import { palette } from 'src/styles/colors';
import styled, { css } from 'styled-components';
import { LinkPlainInternal } from '../links/Link.plain';
import { layout } from 'src/styles/layout';

const LOGO_MOVEMENT_TIME_IN_MILLISECONDS = 500;

export interface LogoContainerProps {
  heightTransitionTime?: number; // Only used if increaseLogoSvgSize is true
  textColorTheme: HeaderDesignControllerContextData['textColorTheme'];
  isClickable?: boolean;
}

export const LogoContainer = styled(LinkPlainInternal).withConfig<LogoContainerProps>({
  // Since this is extending an HTML element, we need to tell styled-components to forward the props
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['centered', 'increaseLogoSvgSize', 'heightTransitionTime', 'textColorTheme', 'isClickable'].includes(prop) &&
    defaultValidatorFn(prop),
})`
  overflow: hidden;
  position: relative;
  z-index: 2;
  transition: all ${LOGO_MOVEMENT_TIME_IN_MILLISECONDS}ms ease-in-out;
  top: 0;
  left: 5rem;
  transform: translate(0, 0);

  ${(props) =>
    props.isClickable
      ? ''
      : css`
          pointer-events: none;
          cursor: default;
        `}

  ${(props) =>
    props.textColorTheme === 'light'
      ? ''
      : css`
          path {
            fill: ${palette.greyText};
          }
        `}

  .animated-mighty-logo-container {
    transition: width ${({ heightTransitionTime }) => heightTransitionTime ?? 500}ms ease-in-out;
  }

  /* Adapt left margin based on the screen width */
  @media screen and (min-width: ${layout.xxlg}) {
    &.force-scale {
      left: 10vw;
    }
  }

  @media screen and (max-width: ${layout.subxlg}) {
    left: 3rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    left: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    > svg {
      max-width: 132px;
    }
  }
`;
